export default class GeneTesting {
  positiveTest = []

  negativeTest = []
}
